export const contextKeys = ['blueprintArn'];
export const initDataKeyList = ['gandalfToken', 'exemptGandalfToken', ...contextKeys];
